module.exports = __webpack_public_path__ + "img/jardin7.f198cc69.jpg";